module.exports = __webpack_public_path__ + "static/media/GretaArabicBold.abd1ce09.ttf";